module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m3-114473a1be05595337293e6e64eb54c2.png";